export default __webpack_public_path__ + "static/media/goodDay-miniature.9f0c2626.png";